<template>
  <div>
    <b-card :title="$t('lab.add-patient-to-test')">
      <b-card-text>
        <b-row>
          <b-col md="12">
            <AutoComplete
              :label="$t('lab.patient_name')"
              :placeholder="$t('lab.patient_name')"
              v-model="patientCardId"
              :serializer="(val) => val.patient_card.id"
              param-query="filter[id]=-id"
              other-query="include=patientCard"
              endpoint="patient-lab"
              text-title="name"
              style="flex: 1"
            />
            <p class="text-danger mt-1">{{ errorForm.patient_card_id }}</p>
          </b-col>
        </b-row>
        <b-row>
          <!-- {{ EditForm.values }} -->
        </b-row>

        <b-row class="mt-3" v-if="data.length > 0">
          <b-col md="12" v-for="(item, index) in data" :key="item.id">
            <b-card>
              <b-card-text class="text-center">
                <h4>{{ item.category }}</h4>
                <b-row class="d-flex justify-content-between mt-4">
                  <b-col>
                    <b-form-group
                      :label="$t('lab.flied-name')"
                      label-for="flied_name"
                    >
                      <h5>{{ item.name }} :</h5>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <!-- <b-form-group :label="$t('lab.value')" label-for="value"> -->
                      <v-select
                        v-model="EditForm.values[index]"
                        :options="JSON.parse(item.options) || []"
                        :placeholder="$t('lab.value')"
                        taggable
                        class="mt-1"
                      />

                      <p class="text-danger mt-1">
                        {{ errorForm.values[index] }}
                      </p>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col>
                    <b-form-group
                      :label="$t('lab.reference-range')"
                      label-for="reference_range"
                    >
                      <h5>{{ item.reference_range }}</h5>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col md="12">
            <b-button @click="submitItem" variant="primary" block>
              {{ $t("common.submit") }}
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import Datepicker from "vuejs-datepicker";
const IVF = () => import("@/components/printables/IVF.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import AutoComplete from "@/components/common/AutoComplete.vue";
import axios from "axios";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    AutoComplete,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        values: [],
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        values: [],
      },
      params: {
        form: {},
        path: "",
      },

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      testReportName: "",
      testId: "",
      searchFromToBy: [
        {
          key: "created_at",
          label: this.$t("bloodBank.created_at"),
          from: "created_at-ge",
          to: "created_at-le",
        },
      ],
      testReportId: "",
      form: [],
      patientCardId: "",
    };
  },
  mounted() {
    this.testReportId = this.$route.params.test_report_id;
    this.getTestReportFlieds();
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    getDefualtValue(item) {
      return item.default ? item.default : "";
    },
    async getTestReportFlieds() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testReportField?page=&take=100&sort=-id&include=testReport&filter[test_report_id]=${this.testReportId}`;

      await this.getList(url);
      this.dataCount = this.all_data.total;

      // Sort the data by category
      this.data = this.all_data.data.sort((a, b) => {
        if (a.category < b.category) return -1;
        if (a.category > b.category) return 1;
        return 0;
      });

      this.EditForm.values = [
        ...this.data.map((item) => this.getDefualtValue(item)),
      ];
      console.log("this.EditForm.values", this.EditForm.values);
      this.form = this.data.map((item) => {
        return {
          name: item.name,
          reference_range: item.reference_range,
          category: item.category,
          value: this.getDefualtValue(item),
          is_required: item.is_required,
        };
      });
      this.data.forEach((item, index) => {
        this.errorForm.values[index] = "";
      });
      this.errorForm.patient_card_id = "";

      this.loading = false;
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.form.forEach((item, index) => {
        item.value = this.EditForm.values[index];
      });
      this.errorForm.patient_card_id = "";
      this.data.forEach((item, index) => {
        this.errorForm.values[index] = "";
      });

      if (!this.patientCardId) {
        count++;
        this.errorForm.patient_card_id =
          "The patient card id field is required.";
      }
      this.form.forEach((item, index) => {
        if (item.is_required === 1 && item.value == null) {
          count++;
          this.errorForm.values[index] = "The value field is required.";
        }
      });

      console.log("editForm", this.EditForm);
      if (count > 0) {
        console.log("count", count);
        this.loading = false;
        return false;
      }
      this.form.forEach((item, index) => {
        delete item.is_required;
      });

      //   console.log("this.form", this.form);

      const finalForm = {
        test_report_id: this.testReportId,
        patient_card_id: this.patientCardId,
        data: this.form,
      };
      console.log("finalForm", finalForm);
      //   alert(JSON.stringify(finalForm));
      //   return 0;
      this.createMode = true;

      if (this.createMode) {
        (this.params.form = finalForm),
          (this.params.path = `/testReportResult`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              alert(JSON.stringify(response));
              this.$router.push({
                name: "test-report-result",
              });
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/testReport/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getTestReportFlieds();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
